export default __webpack_public_path__ + "static/media/stockHistory.541dd8d5.svg";